import { CommonModule, DOCUMENT } from '@angular/common';
import {
  Component,
  Inject,
  inject,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BarraBusquedaBusesComponent } from 'src/app/components/barra-busqueda-buses/barra-busqueda-buses.component';
import { seo } from 'src/assets/seo';
import { Texto_sitio } from '../../../assets/text_site';
import { SeoService } from '../../services/seo.service';
import { SesionService } from '../../services/sesion.service';
import { WebServicesService } from '../../services/web-services.service';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MetodosPagosComponent } from '../../components/metodos-pagos/metodos-pagos.component';
import { FooterComponent } from '../../components/footer/footer.component';
import * as snippet from '../swiper.snippetcode';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-container-buses',
  templateUrl: './container-buses.component.html',
  styleUrls: ['./container-buses.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  providers: [
    SeoService,
    SesionService,
    WebServicesService,
    CookieService,
    Texto_sitio,
    seo,
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    ReactiveFormsModule,
    BarraBusquedaBusesComponent,
    MetodosPagosComponent,
    TranslateModule,
    FooterComponent,
  ],
})
export class ContainerBusesComponent implements OnInit {
  @ViewChild(BarraBusquedaBusesComponent)
  barraBusqueda: BarraBusquedaBusesComponent;

  public centeredSlide1Index = 1;
  public centeredSlide2Index = 2;

  public _snippetCodeSwiperCenteredSlides2 =
    snippet.snippetCodeSwiperCenteredSlides2;

  public swiperCenteredSlides2: SwiperConfigInterface = {
    spaceBetween: 10,
    slidesPerView: 1.5,
    autoplay: { delay: 3000 },
    centeredSlides: false,
  };
  public swiperCenteredSlides1: SwiperConfigInterface = {
    spaceBetween: 0,
    pagination: true,
    loop: true,
    slideToClickedSlide: true,
    slidesPerView: 1,
    autoplay: { delay: 3000 },
  };

  todoElIdioma: any;
  busquedasUsuario: any[] = [];
  topCiudades: any[] = [];
  idCiudadActualTop = 0;
  mostrarCardBusquedas: boolean = false;
  hiddenMobile: boolean = false;
  hiddenPc: boolean = false;
  canonicalUrl: any;
  lang: string = 'es';
  // private deviceService = inject(DeviceDetectorService);

  constructor(
    public seo: SeoService,
    public sesion: SesionService,
    public ws: WebServicesService,
    public titleBrowser: Title,
    private texto_sitio: Texto_sitio,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private cookieService: CookieService,
    private translateService: TranslateService,
    private deviceService: DeviceDetectorService,
    public activatedRoute: ActivatedRoute
  ) {
    this.ws.isMobile = this.deviceService.isMobile();
    this.ws.isTablet = this.deviceService.isTablet();
    this.ws.isDesktopDevice = this.deviceService.isDesktop();
    this.lang = this.translateService.currentLang;

    // this.todoElIdioma = this.texto_sitio.spain.contenedor;
    !this.ws.isMobile && !this.isMobile()
      ? (this.hiddenMobile = true)
      : (this.hiddenPc = true);
    if (!this.ws.isMobile) {
      this.swiperCenteredSlides2.slidesPerView = 5;
    }
  }
  isMobile() {
    return typeof window !== 'undefined' ? window.innerWidth <= 992 : false;
  }
  // eliminarPorDia() {
  //   let day: any = new Date().getDate();
  //   let month: any = new Date().getMonth() + 1;
  //   let year: any = new Date().getFullYear();
  //   day = day.toString();
  //   month = month.toString();
  //   year = year.toString();
  //   let amount = day + month + year;
  //   amount = Number(amount);
  //   const amount_last = (typeof localStorage !== 'undefined') ? localStorage.getItem("amount_last") : "";
  //   if (!amount_last) {
  //     (typeof localStorage !== 'undefined') ? localStorage.setItem("amount_last", amount) : false;
  //   }
  //   if (amount > amount_last) {
  //     if(typeof localStorage !== 'undefined'){
  //       localStorage.clear();
  //       localStorage.setItem("amount_last", amount);
  //     }
  //   }
  // }
  ngOnInit(): void {
    // this.eliminarPorDia();
    // this.createArraySearch();
    if (this.cookieService.get('utm_source') == 'apphites') {
      this.cookieService.set('utm_source', '', 0);
    }
    this.seo.generaAPP('pasajes');

    this.lang = this.translateService.currentLang;

    let langPage: string = this.activatedRoute.snapshot.params.lang || 'es';
    let titlePage: string = `Pasajes en Bus Baratos → ¡Compra tus Pasajes en Chilepasajes.cl!`;
    let descriptionPage: string = `Compra Pasajes de Bus baratos para todo Chile. Compara precios de Pullman Bus, Buses Altas Cumbres, Flixbus, Jet sur, Transantin y más. ¡Ahorra en tus viajes y reserva tus pasajes ahora!`;
    let keywordsPage: string = ``;

    this.seo.UpdateSEO(titlePage, descriptionPage, keywordsPage, langPage);

    this.seo.addStructuredData(this.seo.schemaOrganization, this.document);
    this.seo.addStructuredData(this.seo.schemaSite, this.document);

    //this.seo.generarSEO();
    // let lang = this.lang;
    // if (lang == "es") {
    //   this.todoElIdioma = this.texto_sitio.spain.contenedor;
    // } else {
    //   this.todoElIdioma = this.texto_sitio.english.contenedor;
    // }
    let y =
      typeof document !== 'undefined'
        ? document.querySelector('body')
        : new HTMLBodyElement();
    y.setAttribute('style', 'overflow: display !important;');
  }
  /**
   * Contruye un array donde se almacenan
   * las ultimas tres busquedas del usuario
   */
  // createArraySearch() {
  //   this.busquedasUsuario = this.sesion.getSearch();
  //   if (this.busquedasUsuario && this.busquedasUsuario.length > 0) {
  //     this.busquedasUsuario.forEach((elemento, indice) => {
  //       elemento.cityOrigin = elemento.origin[0];
  //       elemento.cityDestination = elemento.destination[0];
  //       let fechaTemporal = new Date();
  //       fechaTemporal.setMonth(elemento.fechaIda.month - 1);
  //       let mesEnPalabra = fechaTemporal.toLocaleString('es-ES', { month: 'long' })
  //       elemento.dateStart = `${elemento.fechaIda.day} de ${mesEnPalabra}`
  //     });
  //     this.mostrarCardBusquedas = true;
  //   }
  // }
  /**
   * Llama a la funcion cambiarBusqueda, la cual modifica
   * los inputs de la busqueda para realizar una nueva busqueda
   * @param item
   */
  // selectSearch(item) {
  //   let origin;
  //   let destination;
  //   origin = item.cityOrigin.replace(" ", "-");
  //   origin = item.cityOrigin.replace(" ", "-");
  //   origin = item.cityOrigin.replace(" ", "-");
  //   destination = item.cityDestination.replace(" ", "-");
  //   destination = item.cityDestination.replace(" ", "-");
  //   destination = item.cityDestination.replace(" ", "-");
  //   item.origin = origin;
  //   item.destination = destination;
  //   this.barraBusqueda.cambiarBusqueda(item);
  // }
  // capitalice(word: string) {
  //   if (!word) return word;
  //   return `${word[0].toUpperCase()}${word.substr(1).toLowerCase()}`;
  // }
  // generateUrl(url) {
  //   return `/${this.sesion.lang}/${url}`;
  // }
  // ir(url) {
  //   this.router.navigateByUrl(`es/${url}`);
  // }
  // create_seo() {
  //   let lang = this.lang;
  //   this.seo.UpdateSEO('chilepasajes', 'inicio', lang);
  // }
}
